import React, { createContext,Component} from "react";
import axios from 'axios'
import Routes from '../routes/Routes';
export const MyContext = createContext();


const Axios = axios.create({
    baseURL: Routes.global.url_login
});


class MyContextProvider extends Component{
    constructor(){
        super();
        this.isLoggedIn();
    }

    // Root State
    state = {
        showLogin:true,
        isAuth:false,
        theUser:null,
    }
    
    // Toggle between Login & Signup page
    toggleNav = () => {
        const showLogin = !this.state.showLogin;
        this.setState({
            ...this.state,
            showLogin
        })
    }

    // On Click the Log out button
    logoutUser = () => {
        
        localStorage.removeItem('loginToken');
        this.setState({
            ...this.state,
            isAuth:false,
        })
       

    }

    registerUser = async (user) => {

        // Sending the user registration request
        const register = await Axios.post('register.php',{
            name:user.name,
            documento:user.documento,
            ciudad:user.ciudad,
            licencia:user.licencia,
            email:user.email,
            clave:user.clave,
            tipo_usuario:user.tipo_usuario,
            t_persona:user.t_persona,
            tdoc:user.tdoc,
            domicilio:user.domicilio,
            nombre_r_legal:user.nombre_r_legal,
            cedula_r_legal:user.cedula_r_legal,
            contacto_empresarial:user.contacto_empresarial,
            telefono_contacto:user.telefono_contacto
        });

        return register.data;
    }


    loginUser = async (user) => {

        // Sending the user Login request
        const login = await Axios.post('login.php',{
           // email:user.email,
            documento:user.documento,
            clave:user.clave
        });
        return login.data;
    }

    // Checking user logged in or not
    isLoggedIn = async () => {
        const loginToken = localStorage.getItem('loginToken');

        // If inside the local-storage has the JWT token
        if(loginToken){

            //Adding JWT token to axios default header
            Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;

            // Fetching the user information
            const {data} = await Axios.get('user-info.php');

            // If user information is successfully received
            if(data.success && data.user){
                this.setState({
                    ...this.state,
                    isAuth:true,
                    theUser:data.user
                });
            }

        }
    }

    render(){
        const contextValue = {
            rootState:this.state,
            toggleNav:this.toggleNav,
            isLoggedIn:this.isLoggedIn,
            registerUser:this.registerUser,
            loginUser:this.loginUser,
            logoutUser:this.logoutUser
        }
        return(
            <MyContext.Provider value={contextValue}>
                {this.props.children}
            </MyContext.Provider>
        )
    }

}

export default MyContextProvider;